export default {
  comments: [],
};
